import { render, staticRenderFns } from "./FgSurvey.vue?vue&type=template&id=2a518e5a&scoped=true&lang=html&"
import script from "./FgSurvey.vue?vue&type=script&lang=js&"
export * from "./FgSurvey.vue?vue&type=script&lang=js&"
import style0 from "./FgSurvey.vue?vue&type=style&index=0&id=2a518e5a&scoped=true&lang=scss&"
import style1 from "./FgSurvey.vue?vue&type=style&index=1&id=2a518e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a518e5a",
  null
  
)

export default component.exports